import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-circle-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C393 8 504 119 504 256S393 504 256 504 8 393 8 256 119 8 256 8zM227.1 151.6L302.6 224H120C106.7 224 96 234.7 96 248V264C96 277.3 106.7 288 120 288H302.6L227.1 360.4C217.4 369.7 217.2 385.2 226.7 394.7L237.7 405.6C247.1 415 262.3 415 271.6 405.6L404.3 273C413.7 263.6 413.7 248.4 404.3 239.1L271.6 106.3C262.2 96.9 247 96.9 237.7 106.3L226.7 117.2C217.2 126.8 217.4 142.3 227.1 151.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-circle-right.js
// module id = VAZJ
// module chunks = 144